import ExpenseService from '@/api/ExpenseService'

// initial state
const state = {
  expenses: [],
  expense: null,
  nextExCode: null,
  descriptionLists: [],
}

// getters
const getters = {
  getExpenses: state => state.expenses,
  getExpense: state => state.expense,
  getNextExCode: state => state.nextExCode,
  getExpenseDescriptionLists: state => state.descriptionLists,
  getExpenseStatus: (state) => (expense, $t, mixin) => {
    let debtAmount = mixin.getDebtExpenseAmount(expense)
    let isPaid = true

    // end this line if this po has rejected
    if (expense.status == 'rejected') {
      return {
        message: $t('status.ex.rejected'),
        status: 'rejected',
      }
    }
    // end this line if this po is padding
    if (expense.status == 'padding') {
      return {
        message: $t('status.ex.padding'),
        status: 'padding',
      }
    }

    // set value
    if (expense.reference.payments.length == 0) {
      isPaid = false
    } else {
      for (let i in expense.reference.payments) {
        if (expense.reference.payments[i].status != 'paid') {
          isPaid = false
        }
      }
      if (debtAmount > 0) {
        isPaid = false
      }
    }
    // set value ended

    if (!isPaid) {
      return {
        message: $t('status.ex.topay'),
        status: 'uncompleted',
      }
    }

    return {
      message: $t('status.ex.completed'),
      status: 'completed',
    }
  },
  getExpenseInfo: (state) => (ex_id) => {
    return state.expenses.find(exp => exp.ex_id == ex_id)
  },
}

// mutations
const mutations = {
  setExpenses (state, data) {
    state.expenses = data
  },
  setExpense (state, data) {
    state.expense = data
  },
  setNextExCode (state, data) {
    state.nextExCode = data
  },
  setExpenseDescriptionLists (state, data) {
    state.descriptionLists = data
  },
  updateExpenseStatus (state, data) {
    if (state.expense) {
      if (state.expense.ex_id == data.ex_id) {
        state.expense.status = data.status
      }
    }
    if (state.expenses.length > 0) {
      state.expenses.map((p, idx) => {
        if (p.ex_id == data.ex_id) {
          return p.status = data.status
        }
      })
    }
  },
  updateExpensePaymentStatus (state, data) {
    if (state.expense) {
      state.expense.reference.payments.map(payment => {
        if (payment.pe_id == data.pe_id) {
          payment.status = data.status
        }
      })
    }
  },
}

// actions
const actions = {
  async getExpenses ({ commit }, params = {}) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getExpenses') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getExpenses')

      let response = await ExpenseService.getAll(params)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getExpenses')

      result = response.data

      if (result.success) {
        commit('setExpenses', result.data)
        this.dispatch('setPagination', result.meta)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearExpenses ({ commit }) {
    commit('setExpenses', [])
  },
  async getExpense ({ commit }, data) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getExpense') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getExpense')

      let response = await ExpenseService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getExpense')

      result = response.data

      if (result.success) {
        if (result.data.length > 0) {
          commit('setExpense', result.data[0])
        } else {
          // not found data
          this.dispatch('Error', 'Not found data')
        }
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearExpense ({ commit }) {
    commit('setExpense', null)
  },
  async insertExpense ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      const response = await ExpenseService.insert(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        // success
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getNextExCode ({ commit }) {
    var result = null

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getNextExCode') >= 0) return

    try {
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getNextExCode')

      let response = await ExpenseService.getLatestCode()

      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getNextExCode')

      result = response.data

      if (result.success) {
        commit('setNextExCode', result.data.next)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async getExpenseDescriptionLists ({ commit }) {
    var result

    // check this api is still loading or not
    if (this.state.app.loadinglist.indexOf('getExpense') >= 0) return

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)
      // add loadinglist
      this.dispatch('addLoadinglist', 'getExpense')

      let response = await ExpenseService.getDescriptionLists()

      // stop loading
      this.dispatch('Loading', false)
      // remove loadinglist
      this.dispatch('removeLoadinglist', 'getExpense')

      result = response.data

      if (result.success) {
        commit('setExpenseDescriptionLists', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
  clearExpenseDescriptionLists ({ commit }) {
    commit('setExpenseDescriptionLists', [])
  },
  async deleteExpense ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ExpenseService.delete(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateExpense ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ExpenseService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateExpenseStatus ({ commit }, data) {
    var result = null
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ExpenseService.updateStatus(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('updateExpenseStatus', data)
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  updateExpensePaymentStatus ({ commit }, data) {
    commit('updateExpensePaymentStatus', data)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Expense.js